import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const languages = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'Español', flag: '🇪🇸' }
];

export const LanguageToggle = ({ className = '' }) => {
  const { i18n } = useTranslation();
  
  const currentLang = languages.find(l => l.code === i18n.language) || languages[0];
  
  const toggleLanguage = () => {
    const nextLang = i18n.language === 'en' ? 'es' : 'en';
    i18n.changeLanguage(nextLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className={`flex items-center gap-1.5 px-2 py-1 rounded-lg hover:bg-white/10 transition-colors text-zinc-400 hover:text-white ${className}`}
      title={`Switch to ${i18n.language === 'en' ? 'Español' : 'English'}`}
      data-testid="language-toggle"
    >
      <Globe className="w-4 h-4" />
      <span className="text-sm font-medium">{currentLang.flag}</span>
    </button>
  );
};

export default LanguageToggle;
